import { useCallback } from "react";
import { Scene } from "@babylonjs/core/scene";
import { performCharRotate } from "../../animations";
import { GameState, TURN_LEFT, TURN_RIGHT } from "./types";

type Deps = {
  stateRef: React.MutableRefObject<GameState | null>;
  sceneRef: React.MutableRefObject<Scene | null>;
  speedRef: React.MutableRefObject<number>;
  success: boolean;
  setAnimating: (v: boolean) => void;
  turnSound: (rate?: number) => void;
};

export const useHandleTurn = (deps: Deps) => {
  const { stateRef, sceneRef, speedRef, success, setAnimating, turnSound } = deps;

  const handleTurnLeft = useCallback(async () => {
    const g = stateRef.current;
    const scene = sceneRef.current;
    if (!g || !scene || !g.charMesh || g.isAnimating || success) return;
    g.isAnimating = true;
    setAnimating(true);
    turnSound(speedRef.current);
    await performCharRotate(scene, g.charMesh, -Math.PI / 2, speedRef.current);
    g.charDir = TURN_LEFT[g.charDir];
    g.isAnimating = false;
    setAnimating(false);
  }, [stateRef, sceneRef, speedRef, success, setAnimating, turnSound]);

  const handleTurnRight = useCallback(async () => {
    const g = stateRef.current;
    const scene = sceneRef.current;
    if (!g || !scene || !g.charMesh || g.isAnimating || success) return;
    g.isAnimating = true;
    setAnimating(true);
    turnSound(speedRef.current);
    await performCharRotate(scene, g.charMesh, Math.PI / 2, speedRef.current);
    g.charDir = TURN_RIGHT[g.charDir];
    g.isAnimating = false;
    setAnimating(false);
  }, [stateRef, sceneRef, speedRef, success, setAnimating, turnSound]);

  return { handleTurnLeft, handleTurnRight };
};
